module.exports = __webpack_public_path__ + "static/jordon-conner-unsplash-6c0115073e8a2fb711cb8628fd82c33d.jpg";